import React, { forwardRef, useImperativeHandle } from "react";
import { i18n, useForm } from "src/common";
import { Button, Flex, InputMBO, Validation } from "src/components";
import { FieldConfig, Form, FormConfig, FormRef } from "./form";

export type MboFormItemType = 'insuranceNumber';
export const allMboFormItems: Array<MboFormItemType> = ['insuranceNumber'];

interface MboFormProps {
  initialValues: { insuranceNumber: string };
  formItems?: Array<MboFormItemType>;
  onSubmit?: (values: any) => void;
}

export const MboForm = forwardRef<FormRef, MboFormProps>(({ initialValues, formItems = allMboFormItems, onSubmit }, ref) => {
  const { formRef, submitForm, getValues, setFieldValue, validateForm, scrollIntoView } = useForm();

  useImperativeHandle(ref, () => ({
    submitForm: () => { submitForm(); },
    getValues: () => getValues(),
    setFieldValue: (fieldName: string, value: any, validation?: boolean) => setFieldValue(fieldName, value, validation),
    validateForm: (validateFields?: string[]) => validateForm(validateFields),
    scrollIntoView: () => scrollIntoView(),
  }));

  const handleSubmit = (values: any) => {
    if (onSubmit) onSubmit(values);
  };

  const fields: FieldConfig[] = [
    {
      name: 'insuranceNumber',
      label: i18n.t('components.forms.mboForm.mbo'),
      component: InputMBO,
      componentProps: {
        errorMessageAbsolute: false
      },
      validations: [
        { type: 'required', message: 'Potreban unos' },
        { type: 'validMBO', message: 'Netočan unos. Unesi ispravni MBO.' },
      ] as Validation[],
    }
  ].filter((field) => formItems.includes(field.name as MboFormItemType));

  const formConfig: FormConfig = {
    gap: 24
  };

  return (
    <Flex vertical gap={12}>
      <Form ref={formRef} fields={fields} config={formConfig} onSubmit={handleSubmit} initialValues={initialValues} reduxName='mbo' />
      <Button btnType="primary" text={i18n.t('components.forms.mboForm.submit')} style={{ width: '100%' }} onClick={() => submitForm()} />
    </Flex>
  )
});
